import { useAuthorCooperationRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetAuthorCooperationRequestCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useAuthorCooperationRoutes };

export default GetDefaultIndex({ title: "درخواست‌های همکاری نویسندگان", query: useGetAuthorCooperationRequestCommonInfoQuery });
